import React from 'react';
import BaseFilter from './base_filter';
import RangeFilter from './range_filter';
import { DEFAULT_FILTERS } from './filter_constants_and_helpers';
import _ from 'lodash';

class CaratFilter extends BaseFilter {

    constructor(props) {
        super(props)

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)
        this.updateByItemProp = true
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {
            from: DEFAULT_FILTERS.carat_weight_from,
            to: DEFAULT_FILTERS.carat_weight_to
        }
    }

    _setDefault() {
        this.setFilters(CaratFilter.getFilterName(),this._defaultValue())
    }

    _itemValue(itemFilters){
        return {
            from: itemFilters && itemFilters.carat_weight_from || this.state.from,
            to: itemFilters && itemFilters.carat_weight_to || this.state.to
        }
    }

    _render() {
        return <div><RangeFilter
            fromLabel={"From"}
            toLabel={"To"}
            step={0.1}
            minValue={DEFAULT_FILTERS.carat_weight_from}
            maxValue={DEFAULT_FILTERS.carat_weight_to}
            from={this.state.from}
            to={this.state.to}
            label={"CARAT"}
            name={CaratFilter.getFilterName()}
            setFilters={this.setFilters}
        />
        </div>
    }

    _getFilterValue() {
        return {from:this.state.from,to:this.state.to}
    }

    _getFilterName() {
        return CaratFilter.getFilterName()
    }

    _tagName(value) {
        if ( value.from === value.to ) {
            return [value.from + " CT"]
        }
        return [value.from + "-" + value.to + " CT"]
    }

    _apiKeys() {
        return ['from','to']
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "carat_weight"
    }
}

export default CaratFilter;